import { router, useNavigation } from 'expo-router';
import { useLayoutEffect } from 'react';
import { StyleSheet, View } from 'react-native';

import { useGetMeMutation } from '@/api/hooks/meHooks';
import GoBackButton from '@/components/buttons/GoBackButton';
import DistancesForm from '@/components/forms/DistancesForm';
import GuardWrapper from '@/components/GuardWrapper';
import Title from '@/components/Title';
import { useAuth } from '@/contexts/authContext';
import { useEndFlowModal } from '@/contexts/endFlowModalContext';
import { DistancesData } from '@/lib/validations/AuthSchema';
import { i18n } from '@/utils/i18n';

const EditRange = () => {
  const { state, setCurrentUser } = useAuth();
  const { showSuccess, showError } = useEndFlowModal();
  const { mutateAsync: getMe } = useGetMeMutation();
  const navigation = useNavigation();

  //Locales
  const title = i18n.t('settings.mileage_radius.title');
  const success = i18n.t('end_flow.success_title');
  const success_msg = i18n.t('settings.mileage_radius.success_message');
  const failure = i18n.t('end_flow.error_title');
  const failure_msg = i18n.t('settings.mileage_radius.failure_message');

  useLayoutEffect(() => {
    navigation.setOptions({
      headerTitle: () => <Title label={title} />,
      headerLeft: () => <GoBackButton />
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigation]);

  const successFn = async (_: DistancesData) => {
    await getMe(
      { firebaseId: state.user?.user?.firebaseId ?? '' },
      {
        onSuccess: (data) => {
          setCurrentUser({
            ...data.user,
            onBoardingId: data.onBoardingPreference?.id ?? '',
            address: data.onBoardingPreference?.address ?? '',
            location: data.onBoardingPreference?.location ?? '',
            searchRange: data.onBoardingPreference?.searchRange ?? 100
          });
          showSuccess({
            title: success,
            message: success_msg
          });
          router.back();
        }
      }
    );
  };

  const failureFn = () => {
    showError({
      title: failure,
      message: failure_msg
    });
  };

  return (
    <GuardWrapper canAccess={['INDIVIDUAL']}>
      <View style={styles.container}>
        <DistancesForm
          defaultValues={{
            searchRange: state.user?.user?.searchRange ?? state.user?.onBoardingPreference?.searchRange,
            location: state.user?.user?.location ?? state.user?.onBoardingPreference?.location,
            address: state.user?.user?.address ?? state.user?.onBoardingPreference?.address ?? ''
          }}
          onBoardingId={state.user?.user?.onBoardingId ?? ''}
          onSuccessFn={successFn}
          onFailureFn={failureFn}
          submitLabel={i18n.t('mix.done')}
        />
      </View>
    </GuardWrapper>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 18
  }
});

export default EditRange;
